export enum LinhaProdutoEnum {
  GardenEssencial = 'Garden Essencial',
  GardenEco = 'Garden Eco',
  GardenBio = 'Garden Bio',
  GardenClass = 'Garden Class',
  GardenSensia = 'Garden Sensia'
}
